import { render } from "./BuiltinLoginForm.vue?vue&type=template&id=a534223e&scoped=true&ts=true"
import script from "./BuiltinLoginForm.vue?vue&type=script&lang=ts"
export * from "./BuiltinLoginForm.vue?vue&type=script&lang=ts"

import "./BuiltinLoginForm.vue?vue&type=style&index=0&id=a534223e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a534223e"]])

export default __exports__